module.exports = __webpack_public_path__ + "static/video-journal-intro-d4b63529aa4f9592b518cbaed6038228.mp4";